import {
  List,
  SyncListCreateData,
  SyncListType,
} from '@components/integrations/integrations-types';

import { request } from 'api/request';
import { isInTemplateRoute } from 'ui/router';

export const loadLists = async (search: string = '') => {
  const response = await request.get<List[]>(`v1/company/lists/${search}`);
  return response.data;
};

export const loadList = async (id: string) => {
  const url = isInTemplateRoute() ? `v1/templates/lists/${id}/` : `v1/company/lists/${id}/`;
  const response = await request.get<List>(url);
  return response.data;
};

export const loadTemplateList = async (id: string) => {
  const response = await request.get<List>(`v1/templates/lists/${id}/`);
  return response.data;
};

type CreateOption = {
  value: string;
  label: string;
  shortId?: string;
};

export type CreateListData = {
  name: string;
  description?: string;
  source?: string;
  options: CreateOption[];
  availableInForms?: boolean;
};

export type EditListData = Partial<CreateListData>;

export const createList = async (data: CreateListData) => {
  const response = await request.post('v1/company/lists/', data);
  return response.data;
};

export const editList = async (id: string, data: EditListData) => {
  const response = await request.patch(`v1/company/lists/${id}/`, data);
  return response.data;
};

export const deleteList = async (id: string) => {
  const response = await request.delete(`v1/company/lists/${id}/`);
  return response.data;
};

export async function getListTemplate() {
  const response = await request.get(`v1/company/lists-create-template/`, {
    responseType: 'blob',
  });
  return response.data;
}

export const createSyncList = async (data: SyncListCreateData) => {
  const response = await request.post(`v1/integrations/synced-lists/`, data);
  return response.data;
};

export const patchSyncList = async (id: string, data: Partial<SyncListType>) => {
  const response = await request.patch(`v1/integrations/sync-list/${id}/`, data);
  return response.data;
};

export const syncList = async (id: string) => {
  const response = await request.post(`v1/integrations/sync-list/${id}/`);
  return response.data;
};

export const syncToManualList = async (id: string) => {
  const response = await request.delete(`v1/integrations/sync-list/${id}/`);
  return response.data;
};

export type DynamicListOption = {
  label: string;
  value: string;
};

export const fetchDynamicListOptions = async (
  listShortId: string,
  parameters: Record<string, string>
) => {
  const response = await request.post<DynamicListOption[]>(
    `v1/integrations/lists/${listShortId}/dynamic-options/`,
    { parameters }
  );
  return response.data;
};
